/**
 * Product Personalization JavaScript - Savor Theme Compatible
 *
 * Works with Savor's custom variant picker system
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const fieldsContainer = document.getElementById('personalization-fields');
    const wrapper = document.querySelector('.product-personalization-wrapper');

    if (!fieldsContainer || !wrapper) {
      console.warn('Personalization elements not found');
      return;
    }

    const optionPosition = parseInt(wrapper.dataset.optionPosition);
    const optionName = wrapper.dataset.optionName;

    if (!optionPosition || !optionName) {
      console.error('Product does not have Personalization variant option');
      return;
    }

    // Get inputs
    const inputs = fieldsContainer.querySelectorAll('.personalization-input');
    const hiddenProperty = document.getElementById('personalization-hidden');

    // Get the hidden variant ID input (Savor uses this)
    const variantIdInput = document.querySelector('input[name="id"]');

    if (!variantIdInput) {
      console.error('Variant ID input not found');
      return;
    }

    console.log('Personalization initialized. Option position:', optionPosition);

    // Monitor variant changes multiple ways (Savor uses different methods)

    // Method 1: Watch the hidden input directly
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          console.log('Variant changed via mutation');
          handleVariantChange();
        }
      });
    });

    observer.observe(variantIdInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    // Method 2: Listen for input events
    variantIdInput.addEventListener('change', function() {
      console.log('Variant changed via change event');
      handleVariantChange();
    });

    // Method 3: Listen for custom Savor events
    document.addEventListener('variant:change', function(e) {
      console.log('Variant changed via custom event');
      handleVariantChange();
    });

    // Method 4: Poll for changes (fallback)
    let lastVariantId = variantIdInput.value;
    setInterval(function() {
      if (variantIdInput.value !== lastVariantId) {
        lastVariantId = variantIdInput.value;
        console.log('Variant changed via polling');
        handleVariantChange();
      }
    }, 500);

    // Check initial state
    setTimeout(handleVariantChange, 100);

    function handleVariantChange() {
      const variantId = variantIdInput.value;
      console.log('Checking variant:', variantId);

      if (!variantId) {
        console.log('No variant selected');
        return;
      }

      // Get variant data from the page
      // Savor stores product data in window or data attributes
      let currentVariant = getCurrentVariant(variantId);

      if (!currentVariant) {
        console.warn('Could not find variant data');
        return;
      }

      console.log('Current variant:', currentVariant);

      // Check personalization option value
      const personalizationValue = currentVariant[`option${optionPosition}`];
      console.log('Personalization value:', personalizationValue);

      if (!personalizationValue) {
        console.warn('No personalization value found at option position', optionPosition);
        return;
      }

      const isPersonalizationSelected = personalizationValue.toLowerCase() === 'yes';
      console.log('Is personalization selected:', isPersonalizationSelected);

      if (isPersonalizationSelected) {
        showPersonalizationFields();
      } else {
        hidePersonalizationFields();
      }
    }

    function getCurrentVariant(variantId) {
      // Try to get from ShopifyAnalytics
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        const product = window.ShopifyAnalytics.meta.product;
        const variant = product.variants.find(v => v.id == variantId);
        if (variant) {
          console.log('Found variant via ShopifyAnalytics');
          return variant;
        }
      }

      // Try to get from meta tags or JSON
      const productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        try {
          const product = JSON.parse(productJson.textContent);
          const variant = product.variants.find(v => v.id == variantId);
          if (variant) {
            console.log('Found variant via data-product-json');
            return variant;
          }
        } catch(e) {}
      }

      // Try to get from script tag
      const productScripts = document.querySelectorAll('script[type="application/json"]');
      for (let script of productScripts) {
        try {
          const data = JSON.parse(script.textContent);
          if (data.variants) {
            const variant = data.variants.find(v => v.id == variantId);
            if (variant) {
              console.log('Found variant via script tag');
              return variant;
            }
          }
        } catch(e) {}
      }

      console.warn('Could not find variant data anywhere');
      return null;
    }

    function showPersonalizationFields() {
      console.log('Showing personalization fields');

      // Show container
      fieldsContainer.style.display = 'block';

      // Trigger reflow
      void fieldsContainer.offsetWidth;

      // Add visible class
      setTimeout(() => {
        fieldsContainer.style.opacity = '1';
      }, 10);

      // Enable inputs
      inputs.forEach(input => {
        input.disabled = false;
      });

      if (hiddenProperty) {
        hiddenProperty.disabled = false;
        hiddenProperty.value = 'Yes';
      }
    }

    function hidePersonalizationFields() {
      console.log('Hiding personalization fields');

      // Hide
      fieldsContainer.style.opacity = '0';
      setTimeout(() => {
        fieldsContainer.style.display = 'none';
      }, 300);

      // Disable and clear inputs
      inputs.forEach(input => {
        input.disabled = true;
        if (input.type !== 'file') {
          input.value = '';
        }
      });

      if (hiddenProperty) {
        hiddenProperty.disabled = true;
        hiddenProperty.value = '';
      }
    }

    // Form validation
    const form = variantIdInput.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        if (fieldsContainer.style.display === 'none') {
          return true;
        }

        const errors = [];

        const textField = document.getElementById('personalization-text');
        if (textField && !textField.disabled && !textField.value.trim()) {
          errors.push('Personalization Text is required');
        }

        const logoField = document.getElementById('personalization-logo');
        if (logoField && !logoField.disabled && (!logoField.files || logoField.files.length === 0)) {
          errors.push('Logo Upload is required');
        }

        const mixField = document.getElementById('personalization-mix');
        if (mixField && !mixField.disabled && !mixField.value.trim()) {
          errors.push('Mix Breakdown is required');
        }

        if (errors.length > 0) {
          e.preventDefault();
          alert('Please fill out all personalization fields:\n\n' + errors.join('\n'));
          fieldsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      });
    }
  }

})();
